/// <reference path="../../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export abstract class SingleOutputWorkflowBlock extends BaseWorkflowBlock{
        
        private _toBlock: IWorkflowBlock;

        constructor(id: string, theType: number, label: string) {
            super(id, theType, label);
        }

        public get toBlock(): IWorkflowBlock {
            if (!this.toBlocks || this.toBlocks.length === 0) {
                this._toBlock = undefined;
            } else {
                this._toBlock = this.toBlocks[0];
            }
            return this._toBlock;
        }

        public set toBlock(value: IWorkflowBlock) {
            if (!this.toBlocks) this.toBlocks = [];
            if (this.toBlocks.length === 0) {
                this.toBlocks.push(value);
            } else {
                this.toBlocks[0] = value;
            }
            this._toBlock = value;
        }

        public getOutputType(): Wars.Domain.Model.Codes.Enums.BlockOutputType {
            return Wars.Domain.Model.Codes.Enums.BlockOutputType.Single;
        }
    }
}
